module.exports = __webpack_public_path__ + "img/emailSent.94edd328.svg";